export default interface IBagTextures {
    texDefaultN: THREE.Texture | null;
    texBody: THREE.Texture | null;
    texBodyN: THREE.Texture | null;
}

export class BagTextures implements IBagTextures {
    texDefaultN: THREE.Texture | null = null
    texBody: THREE.Texture | null = null
    texBodyN: THREE.Texture | null = null

    constructor () {
        
    }
}

